import { immerable } from "immer";
import { IssuePriority } from "./issue-priority";

export class FormDataZendeskTicketRequest {
  [immerable] = true;
  typology: string | null = null;
  subTypology: string | null = null;
  subject: string | null = null;
  description: string | null = null;
  techInfos: string | null = null;
  objectId: number | null = null;
  priority: IssuePriority | null = null;
  followers: string[] | null = null;

  constructor(init?: Partial<FormDataZendeskTicketRequest>) {
    Object.assign(this, init);
  }
}
